<ui-sidenav-item
    [menuItem]="menuItem"
    [onClickEvent]="onClickEvent"
    [badgeCount]="count"
/>